import { RenderingLayout } from '../types/nextTypes';

export const PAGE_REGENERATION_INTERVAL = 32140800;

export const ITEMS_PER_PAGE = 16;

export const DEFAULT_PATHS = {
  paths: [
    {
      params: {
        layout: RenderingLayout.Desktop,
      },
    },
    {
      params: {
        layout: RenderingLayout.Mobile,
      },
    },
  ],
  fallback: 'blocking',
};

export const ON_DEMAND_PATHS = {
  paths: [],
  fallback: 'blocking',
};
